/*
 * Gallery gestures
 * Adds mobile swipe (touch) navigation to <product-gallery>.
 * Works alongside the existing arrow buttons and <thumbnail-slider>
 * without breaking them.
 *
 * Mobile: native scroll-snap already handles swipe. We add a fallback
 * that triggers setActiveMedia() when native scroll did not advance
 * (e.g. single-item layouts where only active item is visible).
 *
 * Desktop: unchanged. Users navigate via thumbnails and arrow buttons only.
 */
(function () {
  'use strict';

  if (window.__galleryGesturesLoaded) return;
  window.__galleryGesturesLoaded = true;

  var SWIPE_DISTANCE = 40;
  var SWIPE_MAX_MS = 800;

  function navigableItems(slider) {
    var items = slider.querySelectorAll('.product__media-item');
    var out = [];
    for (var i = 0; i < items.length; i++) {
      var li = items[i];
      // Skip items that are visually hidden via theme rules (variant + gang)
      if (li.classList.contains('product__media-item--variant') && !li.classList.contains('is-active')) {
        // hidden via display:none in CSS - skip
        if (getComputedStyle(li).display === 'none') continue;
      }
      if (li.hasAttribute('data-gang-option') && !li.classList.contains('gang__active')) continue;
      out.push(li);
    }
    return out;
  }

  function nextMediaId(slider, dir) {
    var items = navigableItems(slider);
    if (items.length < 2) return null;
    var idx = -1;
    for (var i = 0; i < items.length; i++) {
      if (items[i].classList.contains('is-active')) { idx = i; break; }
    }
    if (idx === -1) idx = 0;
    var next = idx + dir;
    if (next < 0) next = items.length - 1;
    if (next >= items.length) next = 0;
    return items[next].dataset.mediaId;
  }

  function isNativelyScrollable(slider) {
    return slider.scrollWidth - slider.clientWidth > 4;
  }

  function setupGallery(productGallery) {
    if (productGallery.__gesturesAttached) return;
    productGallery.__gesturesAttached = true;

    var mediaGallery = productGallery.closest('media-gallery');
    var slider = productGallery.querySelector('[id^="Slider-"]') || productGallery.querySelector('.product__media-list');
    if (!slider) return;

    function navigate(dir) {
      var id = nextMediaId(slider, dir);
      if (!id) return;
      if (mediaGallery && typeof mediaGallery.setActiveMedia === 'function') {
        mediaGallery.setActiveMedia(id, false, false);
      }
    }

    // ---------- Touch swipe ----------
    var tStartX = 0, tStartY = 0, tStartT = 0, tStartScroll = 0, tValid = false;

    slider.addEventListener('touchstart', function (e) {
      if (!e.touches || e.touches.length !== 1) { tValid = false; return; }
      tValid = true;
      tStartX = e.touches[0].clientX;
      tStartY = e.touches[0].clientY;
      tStartT = Date.now();
      tStartScroll = slider.scrollLeft;
    }, { passive: true });

    slider.addEventListener('touchend', function (e) {
      if (!tValid) return;
      tValid = false;
      var t = e.changedTouches && e.changedTouches[0];
      if (!t) return;
      var dx = t.clientX - tStartX;
      var dy = t.clientY - tStartY;
      var dt = Date.now() - tStartT;
      if (Math.abs(dx) < SWIPE_DISTANCE) return;
      if (Math.abs(dx) <= Math.abs(dy)) return;
      if (dt > SWIPE_MAX_MS) return;

      // If native scroll handled it, do nothing (avoid double-advance).
      if (isNativelyScrollable(slider)) {
        if (Math.abs(slider.scrollLeft - tStartScroll) > 8) return;
      }
      navigate(dx < 0 ? 1 : -1);
    }, { passive: true });
  }

  function init() {
    var galleries = document.querySelectorAll('product-gallery');
    for (var i = 0; i < galleries.length; i++) setupGallery(galleries[i]);

    // Re-bind any galleries that get rendered later (variant/section refresh).
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('product-gallery')) setupGallery(node);
          else if (node.querySelectorAll) {
            var inner = node.querySelectorAll('product-gallery');
            for (var k = 0; k < inner.length; k++) setupGallery(inner[k]);
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
